// Example: BarbershopProvider.jsx
import { createContext, useEffect, useState, useContext } from "react";
import {
  getbarbershopConfig,
  getBarbershopSchedule,
  getbarbershopDetails,
} from "../api/barbershopApi";

export const BarbershopContext = createContext();

export const BarbershopProvider = ({ barbershopName, children }) => {
  const [config, setConfig] = useState(null);
  const [shopContactDetail, setShopContactDetail] = useState(null);
  const [shopClosedDays, setShopClosedDay] = useState(null);
  const [shopScheduleSetting, setShopScheduleSetting] = useState(null);
  const [shopClosedWeekDays, setShopClosedWeekDays] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        if (barbershopName) {
          const response = await getbarbershopConfig(barbershopName);
          setConfig(response);
          applyTheme(response);
        }
      } catch (error) {
        console.error("Failed to load barbershop config:", error);
      }
    };
    const fetchDetails = async () => {
      try {
        if (barbershopName) {
          const response = await getbarbershopDetails(barbershopName);
          setShopContactDetail(response);
        }
      } catch (error) {
        console.error("Failed to load barbershop config:", error);
      }
    };

    fetchDetails();
    fetchConfig();
  }, [barbershopName]);
  function applyTheme(shopTheme) {
    const root = document.documentElement;

    root.style.setProperty("--background-color", shopTheme.themeColor);
    root.style.setProperty("--primary-color", shopTheme.primaryColor);
    root.style.setProperty("--secondary-color", shopTheme.secondaryColor);
    root.style.setProperty("--card-background", shopTheme.cardColor);
    root.style.setProperty("--text-color", shopTheme.textColor);
    root.style.setProperty("--text-light", shopTheme.textLight);
  }
  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        if (config) {
          const scheduleSetting = await getBarbershopSchedule(config.id);
          setShopClosedWeekDays(
            scheduleSetting.weeklySchedule
              .filter((day) => day.isClosed)
              .map((day) => day.day)
          );
          setShopScheduleSetting(scheduleSetting.weeklySchedule);
          setShopClosedDay(scheduleSetting.closedDays);
          setLoadingConfig(false);
        }
      } catch (error) {
        console.error("Failed to load barbershop schedule:", error);
      }
    };
    fetchSchedule();
  }, [config]);
  return (
    <BarbershopContext.Provider
      value={{
        config,
        shopContactDetail,
        shopClosedDays,
        shopScheduleSetting,
        shopClosedWeekDays,
        loadingConfig,
      }}
    >
      {children}
    </BarbershopContext.Provider>
  );
};
export default BarbershopProvider;
